import { Box, Grid } from "@mui/material";

import ModalTrigger from "../Common/ModalTrigger";

import csv3 from "../../Data/MANCP/Pesticides/MANCP-Distribution-of-quantified-results-per-sample.csv";
import csv2 from "../../Data/MANCP/Pesticides/MANCP-Frequency-of-MRL-exceedances-per-pesticide.csv";

import BoxPlotChart from "../Charts/BoxPlotChart";
import FrequencyDataGrid from "./FrequencyDataGrid";
import HistogramChart from "../Charts/HistogramChart";

const PesticideResiduesResults = (props) => {
  return (
    <Grid
      item
      container
      direction={{ xs: "column", sm: "column", md: "row" }}
      sx={{ marginTop: { xs: "50px", sm: "50px", md: "90px" } }}
    >
      <Grid display="flex" justifyContent="center" alignItems="center">
        <Grid
          item
          xs
          sx={{
            paddingLeft: { xs: "24px", sm: "24px", md: "24px" },
            paddingRight: { xs: "24px", sm: "40px", md: "24px" },
            paddingBottom: { xs: "24px", sm: "24px", md: "24px" },
            paddingTop: { xs: "24px", sm: "24px", md: "50px" },
            maxWidth: { md: "450px !important" },
          }}
          className="three-one"
        >
          <Box
            sx={{
              textAlign: { xs: "left", sm: "center", md: "left" },
            }}
          >
            <h3>Results by pesticide</h3>
            <p className="paragraph">
              In 2023, reporting countries submitted to EFSA more than 26 million analyses of food commodities tested for pesticide residues. The number of analyses for which residue levels were{" "}
              <ModalTrigger
                style={{
                  color: "#fff",
                  cursor: "pointer",
                  borderBottom: "1px dotted",
                }}
                text="quantified"
              />{" "}
              at or above the LOQ was 147,249 (i.e. 0.6% of the total analyses reported).
            </p>

            <p className="paragraph">
             In total, the maximum number of different pesticides analysed by the{" "}
              <ModalTrigger
                style={{
                  color: "#fff",
                  cursor: "pointer",
                  borderBottom: "1px dotted",
                }}
                text="reporting countries"
              />{" "}
              was 741. On average, 249 different pesticide residues were analysed per sample. Countries analysing more than 600 pesticides in the scope of analytical methods were: Malta (741 pesticides), Germany (717 pesticides), Belgium (631 pesticides), Luxembourg (627 pesticides), Spain (625 pesticides), Austria (618 pesticides) and Croatia (602 pesticides).
            </p>
            <p className="paragraph">
              Of the 132,793 samples analysed, 42.0% (55,831) of samples contained one or several pesticides in measurable concentrations.{" "}
              <ModalTrigger
                style={{
                  color: "#fff",
                  cursor: "pointer",
                  borderBottom: "1px dotted",
                }}
                text="Multiple residues"
              />{" "}
              were reported in 25.5% (33,872) of samples; up to 37 different pesticides were reported in an individual sample of chili peppers from Cambodia. The sample was deemed non-compliant, and the product lot from the wholesale was destroyed.
            </p>
          </Box>
        </Grid>
      </Grid>
      <Grid item xs width={{ xs: "380px", sm: "100%" }}>
        <Grid item xs p={3} className="three-two">
          <FrequencyDataGrid
            title="Frequency of MRL exceedances per pesticide"
            csv={csv2}
          />
        </Grid>

        <Grid item xs p={3}>
          <BoxPlotChart
            title="Distribution of number of results per sample"
            csv={csv3}
          />
          <HistogramChart csv={csv3} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PesticideResiduesResults;
